export interface IDegreeType {
  name: string;
  value: string;
}

class DegreeTypeCodeList {
  degreeTypes: IDegreeType[];

  constructor() {
    this.degreeTypes = [
      /*{
        name: "Early childhood education", 
        value: "0"
      },
      {
        name: "Primary education",
        value: "1"
      },
      {
        name: "Lower secondary education",
        value: "2"
      },*/
      {
        name: "High School / GED",
        value: "3"
      },
      {
        name: "Associate",
        value: "4"
      },
      /*{
        name: "Short-cycle tertiary education",
        value: "5"
      },*/
      {
        name: "Bachelor",
        value: "6"
      },
      {
        name: "Master",
        value: "7"
      },
      {
        name: "Doctoral",
        value: "8"
      }
    ];
  }
}

const instance = new DegreeTypeCodeList();

export default instance;


